export default __webpack_public_path__ + "static/media/2405.2105769b.png";